import * as React from 'react'
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  BooleanInput,
  Edit,
  SimpleForm,
  TopToolbar,
  useRecordContext,
  EditButton,
} from 'react-admin'

export const NotificationSettingsList = (props) => {
  return (
    <List {...props} actions={<TopToolbar />} pagination={false}>
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="eventType" label="Event Type" />
        <TextField source="description" label="Description" />
        <BooleanField source="enabled" label="Enabled" />
        <EditButton />
      </Datagrid>
    </List>
  )
}

export const NotificationSettingsEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextField source="eventType" label="Event Type" />
        <TextField source="description" label="Description" />
        <BooleanInput source="enabled" label="Enabled" />
      </SimpleForm>
    </Edit>
  )
}
